import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GolfEventService } from '../../../services/golf-event.service';
import { GolfEvent } from '../../../models/GolfEvent';
import { GolfEventField } from '../../../models/golfeventfield';
import { NgFor, NgIf } from '@angular/common';
import { UiSwitchModule } from 'ngx-ui-switch';

@Component({
  selector: 'app-field',
  standalone: true,
  imports: [NgFor, NgIf, UiSwitchModule],
  templateUrl: './field.component.html',
  styleUrl: './field.component.css'
})
export class FieldComponent implements OnChanges {
  constructor(private golfEventService:GolfEventService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['league'] && this.league) {
      this.getField(this.league.id);
    }
  }

  @Input() league:GolfEvent|null = null;
  field:Array<GolfEventField> = [];

  async getField(golfEventId:number):Promise<void> {
    this.field = await this.golfEventService.searchField(golfEventId);
  }

  async toggleHasPaid(fieldPlayer:GolfEventField) {
    await this.golfEventService.updateFieldHasPaid(fieldPlayer.id, fieldPlayer.hasPaid);
  }
}
